export const EVENTS = {
    ACCEPT: 'accept',
    CANCEL: 'cancel',
    CHANGE: 'change',
    INTERFACE: 'interface',
    UPDATE_MODEL_VALUE: 'update:modelValue',
    SELECT: 'select',
}
